import * as moment from 'moment-timezone';
import merge from 'lodash-es/merge';
import isObject from 'lodash-es/isObject';
import omitBy from 'lodash-es/omitBy';
import isEqual from 'lodash-es/isEqual';

import * as qs from 'qs';
import { FilterParams } from "app/models/filter_form.model";

import * as dictionary from "dict/static.json";

const
	config:any              = dictionary['config'],
	defaultFilterParams:any = dictionary['defaultFilterParams'],
	utmList:any             = [
		'utm_source', 'utm_medium', 'utm_campaign',
		'utm_term', 'utm_content', 'utm_landing',
		'gclid'
	];


export function getAdminMenuTree() {
	return config.adminMenuTree;
}


export function getServerName() {
	return config.serverName;
}


export function RoundDateM (period: string): any {
	let periodMap   = ['hour', 'day', 'week', 'month', 'year'].reduce((o, k) => { o[k] = 1; return o; }, {}),
		roundPeriod:any = period == 'week' ? 'isoWeek' : period;
	
	if (periodMap[period]) {
		return function (date, format) {
			return moment(date, format).tz(config.timezone).startOf(roundPeriod);
		};
	} else if (period == 'summary') {
		return function () {
			return moment(0).tz(config.timezone);
		};
	} else if (period == 'origin') {
		return function (date) {
			return moment(date).tz(config.timezone);
		};
	} else if (period == 'now') {
		let dateM = moment().tz(config.timezone);
		return function () {
			return dateM;
		};
	} else {
		throw new Error('adminStat::RoundDateM: period not found');
	}
}


/**
 * Получить строку с параметрами для GET http-запроса.
 * @param {FilterParams} queryParams
 * @param {FilterParams} addParams
 * @returns {string}
 */
export function getUrlParams(queryParams: FilterParams, addParams?: FilterParams): string {
	let params: FilterParams;
	
	if (addParams) {
		Object.keys(addParams).forEach(p => {
			if (addParams[p]) {
				let data = {};
				data[p] = addParams[p];
				queryParams = merge({}, queryParams, data);
			}
		});
	}
	
	params = merge({}, getDiffParams(queryParams), {t: Date.now()});
	
	if (params.refGroup) {
		params.refGroup = encodeURIComponent(params.refGroup);
	}
	
	if (params.refSource) {
		params.refSource = encodeURIComponent(params.refSource);
	}
	
	return qs.stringify(params, { encode: false });
}


export function paramToQuery(params) {
	return qs.stringify(params, { encode: false });
}


export function limiter(cb, timeout = 300) {
	let timer = null;
	
	return function () {
		let that = this,
			args = arguments;
		
		clearTimeout(timer);
		
		timer = setTimeout(
			function() {
				cb.apply(that, args);
			},
			timeout
		);
	};
}


export function getDiffParams(params: FilterParams): FilterParams {
	
	// Оставить только параметры, отличные от дефолтных
	let diff = omitBy(params, function (v, k) {
		return defaultFilterParams[k] === v;
	});
	
	// Дополнительная проверка для объектов
	Object.keys(diff).forEach(function (key) {
		if (isObject(diff[key])) {
			if (isEqual(defaultFilterParams[key], diff[key])) {
				delete diff[key];
			}
		}
	});
	
	return <FilterParams>diff;
}


export function getSiteStatusStyle(siteData) {
	let styles = {
		color: 'red'
	};

	// по какой-то причине не найден в БД
	if(siteData.notFound) {
		styles.color = 'LightGray';

		return styles.color;
	}

	// желтый - фантоманые, недоделанные в визарде
	if (siteData.markForRemovalAt) {
		styles.color = 'red';
	} else if (siteData.status == -1) {
		styles.color = 'rgb(216, 221, 18)';
	}

	// серый - выключенный
	else if (siteData.status == 0) {
		styles.color = 'gray';
	}

	// Если сайт активен
	else {

		// Если оплачен или включён на халяву
		if (siteData.paidType == 'paid' || siteData.paidType == 'trial' || siteData.inFreemiumMode) {

			// Если сайт опубликован
			if (siteData.datePublished) {
				styles.color = 'green';
			} else {
				styles.color = '#3b7694';
			}
		}

		// Сайт включен, но просрочен
		else {
			styles.color = 'red';
		}
	}

	return styles.color;
}


export function getUtmList() {
	return utmList;	
}


export function getUTMhash(referer:string) {
	let result = {},
		pairs = (referer || '').split('&');
	
	let utmListR = utmList.map(function (utm) {
		return {
			utm: utm,
			r: new RegExp(utm + '=((.*?){2,})')
		};
	});
	
	pairs.forEach(function (paid) {
		utmListR.forEach(function (utmItem) {
			if (paid.match(utmItem.utm)) {
				let val = paid.match(utmItem.r);
				
				if (val && val[1]) result[utmItem.utm] = val[1].replace(/(\/|\\)$/g, '');
			}
		});
	});
	
	return result;
}


export function getCookie(name) {
	var matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}


export function getTimeAsIntervals(opts) {
	let start  = opts.timestamp,
		period = opts.period,
		dates  = [];
	
	if (period == 'day') {
		dates = [
			moment.utc(start).add(3, 'hour').startOf('day').format('DD.MM.YYYY'),
		]
	} else {
		if (period == 'week') {
			dates = [
				moment.utc(start).add(3, 'hour').startOf('isoWeek').format('DD.MM.YYYY'),
				moment.utc(start).add(3, 'hour').endOf('isoWeek').format('DD.MM.YYYY')
			];
		} else if (period == 'month') {
			dates = [
				moment.utc(start).add(3, 'hour').startOf('month').format('DD.MM.YYYY'),
				moment.utc(start).add(3, 'hour').endOf('month').format('DD.MM.YYYY')
			];
		} else if (period == 'year') {
			dates = [
				moment.utc(start).add(3, 'hour').startOf('year').format('DD.MM.YYYY'),
				moment.utc(start).add(3, 'hour').endOf('year').format('DD.MM.YYYY')
			];
		} else if (period == 'summary') {
			dates = [
				''
			];
		}
	}
	
	return dates;
}


/**
 * Установить куку. Взято отсюда "http://learn.javascript.ru/cookie".
 * @param name
 * @param value
 * @param options
 */
export function setCookie(name, value, options?) {
	options = options || {};

	var expires = options.expires;

	if (typeof expires == "number" && expires) {
		var d = new Date();
		d.setTime(d.getTime() + expires * 1000);
		expires = options.expires = d;
	}
	if (expires && expires.toUTCString) {
		options.expires = expires.toUTCString();
	}

	value = encodeURIComponent(value);

	var updatedCookie = name + "=" + value;

	Object.keys(options).forEach(function(propName) {
		updatedCookie += "; " + propName;
		var propValue = options[propName];
		if (propValue !== true) {
			updatedCookie += "=" + propValue;
		}
	});

	document.cookie = updatedCookie;
}



export function parseDate(...args) {
	return moment.apply(this, args).tz(config.timezone);
}


export var currencyLabels = {
	all : 'All',
	usd : '$',
	// rub : '<span style="font-family: PT Rouble;">у</span>',
	rub: 'R',
	brl : 'R$',
	pln : 'zł',
	ngn : '₦'
};

export function mergeFilterParams(...args) {
	return merge({}, ...args);
}
